// src/Api/updateApi.js
import axiosClient from "./axiosClient";

// -------------------- Board Members --------------------

// GET all board members
export const getBoardMembers = () => {
  return axiosClient.get("/update/board-members");
};

// POST a new board member
export const addBoardMember = (memberData) => {
  // memberData: { name, position, email, phone }
  return axiosClient.post("/update/board-members", memberData);
};

// UPDATE a board member by ID
export const updateBoardMember = (memberId, memberData) => {
  return axiosClient.put(`/update/board-members/${memberId}`, memberData);
};

// DELETE a board member by ID
export const deleteBoardMember = (memberId) => {
  return axiosClient.delete(`/update/board-members/${memberId}`);
};

// -------------------- Committee Members --------------------

// GET all committee members
export const getCommitteeMembers = () => {
  return axiosClient.get("/update/committee-members");
};

// POST a new committee member
export const addCommitteeMember = (memberData) => {
  // memberData: { full_name, role, email, phone_number, bio }
  return axiosClient.post("/update/committee-members", memberData);
};

// UPDATE a committee member by ID
export const updateCommitteeMember = (memberId, memberData) => {
  return axiosClient.put(`/update/committee-members/${memberId}`, memberData);
};

// DELETE a committee member by ID
export const deleteCommitteeMember = (memberId) => {
  return axiosClient.delete(`/update/committee-members/${memberId}`);
};

// -------------------- Documents --------------------

// GET all documents
export const getDocuments = () => axiosClient.get("/update/documents");

// POST a new document
export const addDocument = (formData) => {
  return axiosClient.post("/update/documents", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// UPDATE a document by ID
export const updateDocument = (documentId, formData) => {
  return axiosClient.put(`/update/documents/${documentId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// DELETE a document by ID
export const deleteDocument = (documentId) =>
  axiosClient.delete(`/update/documents/${documentId}`);

// -------------------- EC Decisions --------------------

// GET all decisions
export const getDecisions = () => {
  return axiosClient.get("/update/decisions");
};

// POST a new decision
export const addDecision = (decisionData) => {
  // decisionData: { title, description, date }
  return axiosClient.post("/update/decisions", decisionData);
};

// UPDATE a decision by ID
export const updateDecision = (decisionId, decisionData) => {
  return axiosClient.put(`/update/decisions/${decisionId}`, decisionData);
};

// DELETE a decision by ID
export const deleteDecision = (decisionId) => {
  return axiosClient.delete(`/update/decisions/${decisionId}`);
};

// -------------------- Events --------------------

// GET all events
export const getEvents = () => {
  return axiosClient.get("/update/events");
};

// POST a new event
export const addEvent = (eventData) => {
  // eventData: { title, description, date, location, is_published }
  return axiosClient.post("/update/events", eventData);
};

// UPDATE an event by ID
export const updateEvent = (eventId, eventData) => {
  return axiosClient.put(`/update/events/${eventId}`, eventData);
};

// DELETE an event by ID
export const deleteEvent = (eventId) => {
  return axiosClient.delete(`/update/events/${eventId}`);
};
